import withBeaconModal from 'components/packages/beacon/modal'
import { caughtPromise } from 'lib/axios'
import React, { useCallback, useEffect, useState } from 'react'
import QuestionnaireRequestBeacon from '.'
import { getProductToursApi, markBeaconAsShownApi } from './api'

const QuestionnaireRequestBeaconModal = withBeaconModal(QuestionnaireRequestBeacon)

const QuestionnaireRequestBeaconModalWrapper = ({ open }) => {
  const [show, setShow] = useState(false)
  const [disableCheckBox, setDisableCheckBox] = useState(false)

  useEffect(() => {
    const fetchProductTours = async () => {
      const [err, data] = await caughtPromise(getProductToursApi('manual_questionnaire_v1'))
      if (err) console.error('Error fetching product tours:', err)
      if (data?.should_show) {
        setShow(true)
        caughtPromise(markBeaconAsShownApi('manual_questionnaire_v1'))
      } else {
        setShow(false)
      }
    }

    fetchProductTours()
  }, [])

  const onClose = useCallback(() => {
    setShow(false)
  }, [])

  const openModal = useCallback((e) => {
    setShow(true)
    if (e?.detail?.source === 'tutorial-button') setDisableCheckBox(true)
  }, [])

  useEffect(() => {
    setShow(open)
  }, [open])

  useEffect(() => {
    window.addEventListener('open-questionnaire-request-beacon-modal', openModal)

    return () => window.removeEventListener('open-questionnaire-request-beacon-modal', openModal)
  }, [openModal])

  if (!show) return null

  return <QuestionnaireRequestBeaconModal isShow={show} disableCheckBox={disableCheckBox} onClose={onClose} />
}

export default QuestionnaireRequestBeaconModalWrapper
